import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Typography,
  IconButton,
  Paper,
  Grid,
  Box,
} from "@mui/material";
import { ModalBox } from "../../../styles/ModalStyles";
import CloseIcon from "@mui/icons-material/Close";
import { getClienteHabilitado } from "../../http/actions/ClientesAction";
import CheckboxGroup from "../../data/CheckBox";

const AgregarClienteModuloModal = ({ open, onClose, onSubmit, modulo }) => {
  const [clientes, setClientes] = useState([]);
  const [selectedClientes, setSelectedClientes] = useState([]);

  useEffect(() => {
    if (open && modulo) {
      fetchClientes();
      // Inicializar los checkboxes con los clientes ya asociados al módulo
      if (modulo.clientes && modulo.clientes.length > 0) {
        setSelectedClientes(modulo.clientes.map(cliente => cliente.id));
      } else {
        setSelectedClientes([]);
      }
    }
  }, [open, modulo]);

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleCheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSelectedClientes(prev => 
      checked 
        ? [...prev, id]
        : prev.filter(item => item !== id)
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit({
      idModulo: modulo.id,
      idsClientes: selectedClientes
    });
    onClose();
  };

  const handleClose = () => {
    setSelectedClientes([]);
    onClose();
  };

  return (
    <Modal 
      open={open} 
      onClose={onClose}
    >
      <ModalBox sx={{ width: '90%', maxWidth: 800, maxHeight: '90vh', overflow: 'auto' }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
            color: 'grey.500',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Gestionar Clientes del Módulo
          </Typography>
          <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
            Módulo: {modulo?.servicio}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Seleccione los clientes que tendrán acceso a este módulo.
          </Typography>
        </Box>
        
        <form onSubmit={handleSubmit}>
          <Paper 
            elevation={2} 
            sx={{ 
              p: 3, 
              mb: 3,
              bgcolor: 'background.default',
              borderRadius: 2
            }}
          >
            <Grid container spacing={2}>
              <CheckboxGroup
                title="Clientes Disponibles"
                items={clientes}
                selectedItems={selectedClientes}
                onChange={handleCheckboxChange}
                name="clientes"
              />
            </Grid>
          </Paper>

          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary"
            >
              Guardar cambios
            </Button>
            <Button 
              onClick={handleClose} 
              variant="contained" 
              color="error"
            >
              Cancelar
            </Button>
          </Box>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default AgregarClienteModuloModal;